export default __webpack_public_path__ + "static/media/KTSLogo.1a33089b.png";